import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import Photo from '../../photo'

const Item = styled.div`
  ${tw`transition duration-200 ease-in-out transform cursor-pointer`}
`

const QuitTableItem = function ({ row, style }) {
  const renderName = (v) => {
    return v && v.length > 5 ? v.substring(0, 5) : v
  }
  const renderInfo = () => {
    const { original } = row
    const { name = '', id } = original
    return (
      <div className="w-full flex flex-row items-center">
        <Photo src={original.photo} name={name} userId={id} />
        <span>{renderName(name)}</span>
      </div>
    )
  }
  return (
    <Item
      {...row.getRowProps({ style })}
      className="flex px-5 py-1.5 text-gray-700 border-b border-gray-200 hover:bg-gray-100"
      key={row.original.id}
    >
      {row.cells.map((cell) => {
        const { column } = cell
        return (
          <div
            {...cell.getCellProps()}
            key={column.id}
            className={`${
              column.id === 'selection' ? 'mr-5 ' : 'w-1/5 '
            }flex items-center`}
          >
            {column.id === 'name'
              ? renderInfo(cell, column)
              : cell.render('Cell')}
          </div>
        )
      })}
    </Item>
  )
}

export default QuitTableItem
